<template>
  <!--  <a-skeleton :loading="loading" active :paragraph="{width:'100%',rows:5}" :title="false">-->
  <div style="position: relative">
    <div class="inputDiv" v-if="showSearch">
      <div class="opationRow" v-if="showSearchInput">
        <slot>
          <pt-search v-model="searchText" :placeholder="searchPlaceholder == null ? placeholderText : searchPlaceholder" @searchEvent="searchEvent"></pt-search>
        </slot>
      </div>
       <!--加号按钮插槽-->
      <slot name="addButton" v-if="showAdd">
        <div :class="showSearchInput ? 'add-btn':'show-add-btn'">
          <a-button type="primary" shape="circle" icon="plus" @click.stop="clickEvent"></a-button>
        </div>
      </slot>
    </div>
    <slot name="selectOption"></slot>
    <a-spin :spinning="loading">
      <div class="pt-table">
        <el-table :data="dataSource" v-sticky-table-header="stickyTableHeader" ref="ptTable" @sort-change="sortChange" v-bind="$attrs" header-row-class-name="pt-table-header" :height="height" :refs="refs"
                  :row-key="rowKey" @select="select" @select-all="selectAll" @selection-change="selectionChange" @row-click="rowClick"
                  :row-class-name="tableRowClassName" :highlight-current-row="tableHighlight" :header-cell-class-name="handleTheadAddClass">
          <el-table-column
            v-if="showIndex"
            fixed="left"
            type="index"
            label=""
            width="60"
          />
          <slot name="columns"></slot>
          <div slot="empty">
            <slot name="empty"  v-if="$slots.empty">{{$t('baseVO.empty')}}</slot>
            <div  class="emptyDiv"  v-if="!$slots.empty">
              <pt-empty  :description="description?description:$t('baseVO.empty')" ></pt-empty>
            </div>
          </div>
          <div slot="append">
            <slot name="append"></slot>
          </div>
        </el-table>
      </div>
      <div class="table-pagination"  v-if="(total > 0 && total > pagination.pageSize) || moreChoice">
        <div>
          <slot name="footer_left"></slot>
        </div>
        <div>
          <a-pagination
            @change="tablePageChange"
            @showSizeChange="tableSizeChange"
            :total="pagination.total"
            :pageSize="pagination.pageSize"
            :hideOnSinglePage="!moreChoice"
            :showTotal="pagination.showTotal"
            :current="pagination.current"
            :pageSizeOptions="['10','20','50','100']"
            :show-size-changer="moreChoice"
            size="small"
          />


        </div>
      </div>

      <div class="sumDiv" v-if="sumShow && total > 0" :style="total > 0 &&　total > pagination.pageSize ? sumPositionStyle:sumStyle">
        <div class="sumTotalDiv" v-if="sumVO.pendingApprovalShow">
          <div class="sumTitle">
            {{sumVO.pendingApprovalTitle}}
          </div>
          <div class="sumValue">
            {{sumVO.pendingApprovalValue}}
          </div>
        </div>
        <div class="sumTotalDiv" v-if="sumVO.provideShow">
          <div class="sumTitle">
            {{sumVO.provideTitle}}
          </div>
          <div class="sumValue">
            {{sumVO.provideValue}}
          </div>
        </div>
        <div class="sumTotalDiv"  v-if="sumVO.sumShow">
          <div class="sumTitle">
            {{sumVO.sumTitle}}
          </div>
          <div class="sumValue">
            {{sumVO.sumValue}}
          </div>
        </div>
      </div>
    </a-spin>

  </div>

  <!--  </a-skeleton>-->
</template>

<script>
  import { mapState } from 'vuex'
  export default {
    name: 'ptTable',
    components: {},

    props:{
      sumShow:{
        type:Boolean,
        default: false,
      },
      sumVO:{
        type:Object,
        default:null,
      },
      sortVO:{
        type:Object,
        default:null,
      },
      current:{
        default:1,
      },
      showAdd:{
        type:Boolean,
        default: true,
      },
      showSearchInput:{
        type:Boolean,
        default: true,
      },
      showSearch:{
        type:Boolean,
        default: true,
      },
      searchPlaceholder:{
        type:String,
        default:'请输入关键字, 按回车键查询',
      },
      dataSource:{
        type:Array,
        default:()=>{return []}
      },
      refs:{
        type:String,
        default:'table'
      },
      showFooter:{
        type:Boolean,
        default: false,
      },
      rowKey:{
        default:'id'
      },
      height:{
        default:null
      },
      total:{
        default:1,
      },
      size:{
        default:10,
      },
      loading:{
        type:Boolean,
        default: true,
      },
      description:{
        type:String,
        default:null,
      },
      showIndex:{
        type:Boolean,
        default: false,
      },
      tableRowClassName:{
        type:Function,
        default:()=>{}
      },
      stickyTableHeader:{
        type:Number,
        default: 49
      },
      moreChoice:{
        type:Boolean,
        default: true,
      },
    },
    computed: {
      ...mapState({
        tableHighlight: state => state.app.tableHighlight
      })
    },
    data(){
      let _this = this;
      return {
        sumPositionStyle:"position: relative;top: -50px;margin-left: 30px;margin-right: 500px;display:flex;flex-direction: row;align-items: center;",
        sumStyle:"height:50px;margin-left: 30px;display:flex;flex-direction: row; align-items: center;",
        searchText:'',
        placeholderText:this.$t('baseVO.searchPlaceholder'),
        pagination:{
          pageSize:_this.size,
          total:0,
          size:'small',
          current:1,
          hideOnSinglePage:true,
          showTotal:(total)=>{
            return `共${total}条`
          }
        }
      }
    },
    mounted() {
      this.$nextTick(() => {
        this.repairMissingColumns()
      })
    },
    updated() {
      this.$nextTick(() => {
        this.repairMissingColumns()
      })
    },
    watch:{
      current(newValue){
        console.log("改变 current",newValue)
        this.pagination.current = newValue
      },
      total(newValue){
        this.pagination.total = newValue
      },
      size(newValue){
        console.log("改变每页行数",newValue)
        this.pagination.pageSize = newValue
      },
      searchPlaceholder(newValue){
        this.placeholderText = newValue;
      }
    },
    methods:{
      collectTableColumnComponents(children = []) {
        let result = []
        children.forEach(child => {
          if (!child) {
            return
          }
          if (child.$options && child.$options.name === 'ElTableColumn') {
            result.push(child)
          }
          if (child.$children && child.$children.length) {
            result = result.concat(this.collectTableColumnComponents(child.$children))
          }
        })
        return result
      },
      repairMissingColumns() {
        const table = this.$refs.ptTable
        if (!table || !table.store || !table.store.states) {
          return
        }
        const currentColumns = table.store.states._columns || []
        if (currentColumns.length > 0) {
          return
        }
        const columns = this.collectTableColumnComponents(this.$children)
        if (!columns.length) {
          return
        }
        columns.forEach(column => {
          if (!column || !column.columnConfig) {
            return
          }
          const parent = column.columnOrTableParent
          if (!parent) {
            return
          }
          const isSubColumn = !!column.isSubColumn
          const children = isSubColumn && parent.$el
            ? parent.$el.children
            : (table.$refs.hiddenColumns ? table.$refs.hiddenColumns.children : [])
          const columnIndex = typeof column.getColumnElIndex === 'function'
            ? column.getColumnElIndex(children, column.$el)
            : undefined
          table.store.commit(
            'insertColumn',
            column.columnConfig,
            columnIndex,
            isSubColumn ? parent.columnConfig : null
          )
        })
        if (typeof table.store.updateColumns === 'function') {
          table.store.updateColumns()
        }
        if (typeof table.doLayout === 'function') {
          table.doLayout()
        } else if (typeof table.store.scheduleLayout === 'function') {
          table.store.scheduleLayout()
        }
      },
      handleTheadAddClass({row, column, rowIndex, columnIndex}){
        if(this.sortVO){
          if(this.sortVO.orderColumn != null && this.sortVO.orderColumn != undefined && this.sortVO.orderColumn.indexOf(column.property) > -1){
            if(this.sortVO.orderValue == 'ASC'){
              return  'ascending';
            }else{
              return 'descending';
            }
          }
        }
      },
      clickEvent(){
        this.$emit('add')
      },
      doLayout(){
        console.log("重新布局")
        this.$nextTick(()=>{
          return this.$refs.ptTable.doLayout();
        })
      },
      cleanSortVO(){
        console.log("cleanSort")
        this.$refs.ptTable.clearSort()
      },
      //获取表格refs对象
      getTableRefs(){
        return this.$refs[this.refs];
      },
      searchEvent(){
        this.$emit('search',this.searchText)
      },
      toggleRowSelection(row){
        console.log("设置选中",row)
        this.$refs.ptTable.toggleRowSelection(row,true);
      },
      clearSelection(){
        this.$refs.ptTable.clearSelection();
      },
      selectionChange(selection){
        this.$emit('selection-change',selection)
      },
      selectAll(selection){
        this.$emit('select-all',selection)
      },
      select(selection,row){
        this.$emit('select',selection,row)
      },
      rowClick(row,column,event){
        this.$emit('rowClick',row,column,event);
        this.$store.dispatch('ToggleTableHighlight', true)
      },
      resetCurrent(){
        this.pagination.current = 1
      },
      sortChange( {column, prop, order}){
        console.log(column,prop,order)
        if(order){
          let orderValue = order.replace('ending','').toUpperCase()
          this.$emit('sort-change',prop, orderValue)
        }else{
          this.$emit('sort-change')
        }

      },
      tablePageChange(page, pageSize) {
        this.$nextTick(() => {
          let el = document.getElementById('app')
          let toScrollHeight = el.scrollHeight - document.getElementsByClassName('pt-table')[0].scrollHeight - 134;
          el.scrollTop = toScrollHeight
        })
        this.pagination.current = page
        this.pagination.pageSize = pageSize
        this.$emit('tablePageChange', page, pageSize)
      },

      tableSizeChange(current, size) {
        this.pagination.current = current   // 一般切换条数时重置到第一页
        this.pagination.pageSize = size
        this.$emit('tablePageChange', current, size)
      }

    }
  }
</script>

<style scoped lang="less">
  @import "../../core/diy";
  .sumDiv{
    .sumTotalDiv{
      margin-right: 20px;display: flex;flex-direction: row
    }
    .sumTitle{
      font-size: 16px;color: #333333;
    }
    .sumValue{
      font-size: 16px;color: #333333;margin-left: 5px;
    }
  }
  .inputDiv{
    margin-bottom: 37px;
    position: relative;
    .opationRow{
      display: flex;
      padding: 24px 80px 0px 24px;
      min-height: 56px;
    }
  }
  .add-btn{
    position: absolute;
    right: 24px;
    top: 38px;
    button{
      color: @primary-6;
      box-shadow: 0 7px 9px 0 rgba(59,46,38,0.42);
    }
    button:hover{
      color: @primary-6;
    }
  }
  .show-add-btn{
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-end;
    margin-top: 30px;
    margin-right: 10px;
    button{
      color: @primary-6;
      box-shadow: 0 7px 9px 0 rgba(59,46,38,0.42);
    }
    button:hover{
      color: @primary-6;
    }
  }
  .table-pagination{
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 70px;
  }

  .pt-table /deep/ .el-table__row{
    height: 70px;
    padding-left: 15px;
  }

  .pt-table /deep/ .el-table:before{
    background-color: transparent !important;
  }

  .pt-table /deep/ .el-table__row:hover td{
    background-color: @table-row-hover-bg !important;
  }
  .pt-table /deep/ .current-row td{
    background-color: @table-row-hover-bg !important;
  }
  .hover-row td{
    background-color: @table-row-hover-bg !important;
  }
  .pt-table /deep/ td, .pt-table /deep/ th{
    border-bottom: 5px solid #F4F5F8;
  }
  .pt-table /deep/ th .cell{
    white-space: nowrap;
  }
  .pt-table /deep/ .el-table__row{
    td:first-child{
      .cell{
        padding-left: 30px;
      }
    }
    td:last-child{
      .cell{
        padding-right: 30px;
      }
    }
  }
  .pt-table /deep/ .pt-table-header{
    th:first-child >.cell{
      padding-left: 30px;
    }
    th:last-child >.cell{
      padding-right: 30px;
    }

    th >.cell{
      color: @text-color-9;
      font-size: 14px;
      font-weight: 500;
    }
  }

  .pt-table {
    /deep/ .el-table__header-wrapper{
      .has-gutter th:nth-last-child(2) >.cell{
        padding-right: 30px;
      }
      .has-gutter th:last-child >.cell{
        padding-right: 0;
      }
    }
  }


  .pt-table{
    /deep/ .el-checkbox__input.is-checked .el-checkbox__inner, .el-checkbox__input.is-indeterminate .el-checkbox__inner{
      background-color: @primary-color;
      border-color: @primary-color;
    }
    /deep/ .el-checkbox__inner:hover{
      border-color: @primary-color;
    }
    /deep/ .is-indeterminate > .el-checkbox__inner{
      background-color: @primary-color;
      border-color: @primary-color;
    }

    /deep/ .el-checkbox__input.is-focus .el-checkbox__inner{
      border-color: @primary-color;
    }
    /deep/ .el-table__footer-wrapper tbody td, .el-table__header-wrapper tbody td{
      height: 70px;
      padding-left: 15px;
      background-color: #FFF7F7;
    }
    /deep/ .el-table__fixed-footer-wrapper tbody td{
      height: 70px;
      padding-left: 15px;
      background-color: #FFF7F7;
    }
    /deep/ .el-table__fixed-footer-wrapper .is-hidden{
      visibility: hidden;
    }
  }
  .emptyDiv{
    padding-top: 10px;
    padding-bottom: 10px;
  }
</style>
